<template>
    <div class="PowerToday">
        <Title firstName="日发电趋势" lastName="POWER GENERATION TRENDS TODAY" />
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>今日总发电量</p>
                    <p>{{Number(dayPower).toFixed(2)}}<span> kWh</span></p>

                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="seriesData" :seriesData1="seriesData1" unit="kWh" :xData="xTime" v-if="seriesData.length > 0"/>
                <div class="icon"><span></span> 今日 <span></span> 昨日</div>

            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { number } from 'echarts'
const Title = () => import('../../../components/title/Title')
const Graph = () => import('../../../components/echarts/graph.vue')
import {getTodayYesTime} from '../../../utils/common'
export default {
    props:['areaId'],
    data(){
        return {
            chartId:'powerToday',
            seriesData:[],
            seriesData1:[],
        }
    },
    components:{
        Title,Graph
    },
    mounted(){
        if(this.areaId){
            this.getinverter()
        }
        
    },
    methods:{
        getPowerToday(){
            // if(this.weather.indexOf('阴') != -1 || this.weather.indexOf('云') != -1 || this.weather.indexOf('雨') != -1){

            //     let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
            //     let time = new Date()
            //     let hour = time.getHours() + 1
            //     let arr = seriesData.splice(0,hour)
            //     this.seriesData1 = arr
            //     this.seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]

            // }else{

            //     let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
            //     let time = new Date()
            //     let hour = time.getHours() + 1
            //     let arr = seriesData.splice(0,hour)
            //     this.seriesData1 = arr
            //     this.seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]

            // }
            let _this = this
            let time = getTodayYesTime()
            let today = []
            let yesterday = []
            this.loops.forEach(item =>{
                let data = {
                    deviceLoopId :item.loopId,
                    node:'Daily_Power_Generation_1h',
                    start:`${time.today}T00:00:00Z`,
                    end:`${time.today}T24:00:00Z`
                }
                _this.$http.loopHistorycurve(data).then(res =>{
                    console.log(res);
                    today.push(res.data.data.points)
                })

                let data1 = {
                    deviceLoopId :item.loopId,
                    node:'Daily_Power_Generation_1h',
                    start:`${time.yesterday}T00:00:00Z`,
                    end:`${time.yesterday}T24:00:00Z`
                }
                _this.$http.loopHistorycurve(data1).then(res =>{
                    console.log(res);
                    yesterday.push(res.data.data.points)
                })
            })
            
            setTimeout(()=>{
                console.log(today);
                console.log(yesterday);
                let arr = []
                let arr1 = []
                today[0].forEach((item,index) =>{
                    let val = today[1][index]?Number(today[1][index].val):0
                    let val2 = item.val?Number(item.val):0
                    arr[index] =  Number(val2 + val).toFixed(2)
                })
                yesterday[0].forEach((item,index) =>{
                    let val = yesterday[1][index].val?Number(yesterday[1][index].val):0
                    let val2 = item.val?Number(item.val):0
                    arr1[index] = Number(val2 + val).toFixed(2)
                })
                arr.shift()
                arr1.shift()
                _this.seriesData1 = arr
                _this.seriesData = arr1
            },1000)
            
        },
        async getinverter(){
            let data = {
                areaId :this.areaId
            }
            let res = await this.$http.getinverterarea(data)
            console.log(res);
            this.loops = res.data.data.loops
            this.getPowerToday()
        }
    },
    // watch:{
    //     '$store.state.Cang.weather'(weather){
    //         console.log(weather);
    //         if(weather.indexOf('阴') != -1 || weather.indexOf('云') != -1 || this.weather.indexOf('雨') != -1){
    //             this.$nextTick(()=>{
    //                 let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
    //                 let time = new Date()
    //                 let hour = time.getHours() + 1
    //                 let arr = seriesData.splice(0,hour)
    //                 this.seriesData1 = arr
    //                 this.seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
    //             })
    //         }else{
    //             let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
    //             let time = new Date()
    //             let hour = time.getHours() + 1
    //             let arr = seriesData.splice(0,hour)
    //             this.seriesData1 = arr
    //             this.seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
    //         }
    //     }
    // },
    computed:{
        weather(){
            return this.$store.state.Cang.weather
        },
        xTime(){
            let arr = []
            for(let i = 0;i<=24;i++){
                let one = i<10? '0'+i+':00':i+':00'
                arr.push(one)
            }
            return arr
        },
        dayPower(){
            let sum = 0
            this.seriesData1.forEach(item =>{
                sum += Number(item) 
            })
            return sum
        }
    }
}
</script>

<style lang="less" scoped>
    
    .PowerToday{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0;
                .edataCon{
                    position: relative;
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }

                    
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 16vh;
                position: relative;

                .icon{
                    position: absolute;
                    right: 1vw;
                    top: 0;
                    color: rgba(230,243,253, 0.7);
                    &>span{
                        width: 12rem;
                        height: 12rem;
                        display: inline-block;
                        vertical-align: -1rem;
                        margin-right: 5rem;
                    }
                    &>span:nth-of-type(1){
                        background-color: #f6bd16;
                    }
                    &>span:nth-of-type(2){
                        background-color: #1290ff;
                        margin-left: 5rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>